import React from "react"
import * as MotherMenuSearchFormStyles from "./MotherMenuSearchForm.module.scss"
import Button from "../../../../../lib/common/blocks/button/Button"
import Icon from "../../../../../lib/common/blocks/icon/Icon"
import {navigate} from "@reach/router"

const MotherMenuSearchForm = ({
  site,
  searchTerm,
  triggerParentUpdateSearchTerm,
}) => {

  const handleInputChange = (event) => {
    const term = event.target.value
    triggerParentUpdateSearchTerm(term)
  }
  const getSearchPlaceholder = () => {
    switch (site) {
      case "gc":
        return "Entreprise, PME..."
      case "rh":
        return "Commercial, Paris, CDI..."
      case "sl":
        return "Fibre, 5G, Mobile..."
      default:
        return "Recherche..."
    }
  }

  return (
    <div className={MotherMenuSearchFormStyles.search}>
      <form className={MotherMenuSearchFormStyles.searchForm} onSubmit={()=>{navigate('/search')}}>
        <div className={MotherMenuSearchFormStyles.formControl}>
          <input
            type="search"
            name="q"
            placeholder={getSearchPlaceholder()}
            autoComplete="on"
            value={searchTerm}
            onChange={handleInputChange}
          />
          <Button type="submit">
            <Icon
              icon="search"
              color="var(--secondary-color)"
            />
          </Button>
        </div>
      </form>
    </div>
  )
}

export default MotherMenuSearchForm
